const $ = window.$;
const ObjectToFromData = (data) => {
    let formData = new FormData();
    Object.entries(data).map(function (value, index, array) {
        if ($.isArray(value[1])) {
            value[1].map(function (v, i) {
                if (typeof v === 'object')
                    formData.append(value[0] + "[]", ObjectToFromData(v));
                else
                    formData.append(value[0] + "[]", v);
            })
        } else {
            formData.append(value[0], value[1]);
        }

    })
    return formData;
}
export default ObjectToFromData;
